module.exports = __webpack_public_path__ + "static/media/discarded.9851f2fc.svg";